import script from "./DebugPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugPanel.vue?vue&type=script&setup=true&lang=js"

import "./DebugPanel.vue?vue&type=style&index=0&id=34409c40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34409c40"]])

export default __exports__